module.exports = __webpack_public_path__ + "static/media/promo-viralvault.6cedcb3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-viralvault.jpg
// module id = 328
// module chunks = 0